import { AutoCompleteComponent } from "@syncfusion/ej2-react-dropdowns";
import { RadioButtonComponent } from "@syncfusion/ej2-react-buttons";
import React, { Component } from "react";
import { enableRtl } from "@syncfusion/ej2-base";
import { Button, Spinner } from "react-bootstrap";
// import DatePicker from 'react-datepicker2';
import moment from "moment-jalaali";
import NumberFormat from "react-number-format";
import { Query } from "@syncfusion/ej2-data";
import { Redirect } from "react-router-dom";
import dateicon from "../assets/dateicon.png";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { toast } from "react-toastify";
import { CheckBoxComponent } from "@syncfusion/ej2-react-buttons";

import DatePicker, { DateObject } from "react-multi-date-picker";
// import Toolbar from "react-multi-date-picker/plugins/toolbar"
import "react-multi-date-picker/styles/layouts/mobile.css";
import "react-multi-date-picker/styles/layouts/prime.css";
import "react-multi-date-picker/styles/colors/bluee.css";

enableRtl(true);

export default class CapitalIncrease extends Component {
  constructor(props) {
    super(props);

    this.state = {
      quantitychange: "",
      selectedSymbol: null,
      selectedSymbol1: null,
      selectedBasket: "",
      selectedBroker: "",
      dateValue: moment().format("jYYYY/jMM/jDD"),
      hagheTaghadom: false,
      basketValue: "",
      brokerValue: "",
      Redirect: false,
      dateErrorText: "",
      symbolErrorText: "",
      quantityErrorText: "",
      basketErrorText: "",
      brokerErrorText: "",
      dateFalse: false,
      symbolFalse: false,
      quantityFalse: false,
      basketFalse: false,
      brokerFalse: false,
      maxDateStart: moment().add(0, "days").format("jYYYY/jMM/jDD"),
      options: [],
      isLoading: false,
      currenttseid: "",
      buttonDisabled: false,
      dpsAuto: true,
      submitedSuggestion: [],
      isEdit: null,
      currentBasketLable: "",
      currentBrokerLable: "",
      currentBasketReadolny: false,
      currentBrokerReadolny: false,
    };

    this.fields = { value: "full_name" };
    this.fields1 = { value: "lable" };
    this.fields2 = { value: "full_name" };
    this.query = new Query().where("type_code", "equal", 7);
    this.query1 = new Query().where("type_code", "notequal", 7);
    this.quantitychange = this.quantitychange.bind(this);
    this.resetForm = this.resetForm.bind(this);
    this.getSymbol = this.getSymbol.bind(this);

    this.datepickerr = React.createRef();
  }

  searchSymbol(query) {
    this.setState({ isLoading: true });
    let isright = "stick";
    if (this.state.hagheTaghadom) isright = "right";
    // alert(isright)
    let data = {
      mobile: localStorage.getItem("mobile"),
      token: localStorage.getItem("token"),
      word: query,
      type: isright,
    };

    fetch("/api/searchSymbol", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((resultt) => {
        if (resultt.status === 200) {
          this.setState({ options: resultt.result, isLoading: false });
        } else {
          this.props.history.push("/Login");
        }
      });
  }

  getSymbol(query, id) {
    this.setState({ isLoading: true });
    let data = {
      mobile: localStorage.getItem("mobile"),
      token: localStorage.getItem("token"),
      word: query,
      type: "all",
    };

    fetch("/api/searchSymbol", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((resultt) => {
        if (resultt.status === 200) {
          this.setState({ options: resultt.result }, () => {
            resultt.result.forEach((element) => {
              if (element.id === id) {
                let s = [];
                s.push(element);
                this.setState({ selectedSymbol: element, selectedSymbol1: s });
              }
            });
            this.setState({ isLoading: false });
          });
        } else {
          this.props.history.push("/Login");
        }
      });
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.state.dpsAuto) {
      if (prevProps.userBasketsData !== this.props.userBasketsData) {
        if (this.props.userBasketsData.length > 1) {
          this.acBaskets.readonly = false;
        } else {
          this.acBaskets.readonly = true;
        }
      }
    }
  }

  componentDidMount() {
    if (
      this.props.selectedBrokerId === 0 &&
      this.props.userBrokersData.length < 2
    ) {
      this.setBrokerValue(this.props.userBrokersData[0].full_name, true);
    }

    if (this.props.userBasketsData.length < 2) {
      this.setBasketValue(this.props.userBasketsData[0].lable, true);
    }
  }

  convertDate(date) {
    let timee = new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).formatToParts(date);
    let year = "";
    let month = "";
    let day = "";
    timee.forEach((element) => {
      if (element.type === "year") {
        year = element.value;
      } else if (element.type === "month") {
        month = element.value;
      } else if (element.type === "day") {
        day = element.value;
      }
    });
    let formatedDate = year + "/" + month + "/" + day;
    let pdate = moment(formatedDate, "YYYY/MM/DD").format("jYYYY-jMM-jDD");
    return pdate;
  }

  fixNumber(str) {
    var persianNumbers = [
        /۰/g,
        /۱/g,
        /۲/g,
        /۳/g,
        /۴/g,
        /۵/g,
        /۶/g,
        /۷/g,
        /۸/g,
        /۹/g,
      ],
      arabicNumbers = [
        /٠/g,
        /١/g,
        /٢/g,
        /٣/g,
        /٤/g,
        /٥/g,
        /٦/g,
        /٧/g,
        /٨/g,
        /٩/g,
      ];
    if (typeof str === "string") {
      for (var i = 0; i < 10; i++) {
        str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
      }
    }
    return str;
  }

  dateChange(dateValue) {
    let value = this.fixNumber(new DateObject(dateValue).format("YYYY/MM/DD"));
    this.setState({ dateValue: value });
  }

  acSymbolChange(item) {
    try {
      if (item.length < 1) {
        this.setState({ selectedSymbol: null, selectedSymbol1: null });
        return;
      }
      let s = [];
      s.push(item[0]);
      this.setState({ selectedSymbol: item[0], selectedSymbol1: s });
    } catch (error) {}
  }

  // acSymbolChange1(item){
  //     // this.setState({selectedSymbol:this.acSymbol1.value});
  //     try {
  //         if (item.length<1){
  //             this.setState({selectedSymbol:null});
  //             return;
  //         }
  //         this.setState({selectedSymbol:item[0]});
  //     } catch (error) {

  //     }
  // }

  acBasketChange() {
    this.setState({ selectedBasket: this.acBaskets.value });
  }

  acBrokerChange() {
    this.setState({ selectedBroker: this.acBrokers.value });
  }

  quantitychange(event) {
    this.setState({ quantitychange: event.target.value });
  }

  SubmitFrom() {
    try {
      let selectbasket;
      if (!this.state.dpsAuto) selectbasket = this.acBaskets.value;

      let selectbroker;
      if (!this.state.dpsAuto) selectbroker = this.acBrokers.value;
      // let date=this.convertDate(this.state.dateValue);

      let date = moment(this.state.dateValue, "jYYYY/jMM/jDD").format(
        "jYYYY-jMM-jDD"
      );

      let symbolid;
      let symboltxt;
      if (this.state.selectedSymbol !== null) {
        symbolid = this.state.selectedSymbol.id;
        symboltxt = this.state.selectedSymbol.symbol
          .substring(0, this.state.selectedSymbol.symbol.length - 1)
          .trim();
      }
      let brokerid;
      let basketid;
      let type;

      // this.props.symbolsData.forEach(function(entry) {
      //     if (entry.full_name===selectsymbol){
      //         symbolid=entry.id;
      //     }
      // });

      // alert(symbolid)

      if (!this.state.dpsAuto) {
        this.props.userBasketsData.forEach(function (entry) {
          if (entry.lable === selectbasket) {
            basketid = entry.id;
          }
        });

        this.props.userBrokersData.forEach(function (entry) {
          if (entry.full_name === selectbroker) {
            brokerid = entry.id;
          }
        });
      }

      let quantity = this.state.quantitychange
        .toString()
        .replace(/,/g, "")
        .replace(/ /g, "")
        .replace(/ریال/g, "");

      if (this.state.dateValue === "") {
        this.setState({ dateFalse: true, dateErrorText: "تاریخ نامعتبر است" });
        return;
      } else {
        this.setState({ dateFalse: false, dateErrorText: "" });
      }
      let indexofelement = 2;
      if (this.props.isPopup) indexofelement = 0;
      if (this.state.selectedSymbol === null) {
        document.querySelectorAll(".rbt-input-main")[
          indexofelement
        ].style.border = "1px solid var(--red1)";
        this.setState({
          symbolFalse: true,
          symbolErrorText: "نام نماد باید وارد شود",
        });
        return;
      } else {
        document.querySelectorAll(".rbt-input-main")[
          indexofelement
        ].style.border = "1px solid #ced4da";
        this.setState({ symbolFalse: false, symbolErrorText: "" });
      }
      if (quantity === "") {
        this.setState({
          quantityFalse: true,
          quantityErrorText: "تعداد نامعتبر است",
        });
        return;
      } else if (Number(quantity) < 1) {
        this.setState({
          quantityFalse: true,
          quantityErrorText: "تعداد نمی تواند صفر باشد",
        });
        return;
      } else {
        this.setState({ quantityFalse: false, quantityErrorText: "" });
      }
      if (!this.state.dpsAuto) {
        if (
          this.acBaskets.value === null ||
          this.acBaskets.value === "" ||
          basketid === undefined
        ) {
          this.setState({
            basketFalse: true,
            basketErrorText: "نام سبد نامعتبر است",
          });
          return;
        } else {
          this.setState({ basketFalse: false, basketErrorText: "" });
        }
        if (
          this.acBrokers.value === null ||
          this.acBrokers.value === "" ||
          brokerid === undefined
        ) {
          this.setState({
            brokerFalse: true,
            brokerErrorText: "نام کارگزاری نامعتبر است",
          });
          return;
        } else {
          this.setState({ brokerFalse: false, brokerErrorText: "" });
        }
      }

      let list = [];

      if (this.state.dpsAuto) {
        this.state.submitedSuggestion.forEach(function (entry) {
          if (entry.suggest > 0) {
            var d = {
              basket_id: entry.id,
              broker_id: entry.broker_id,
              quantity: entry.suggest,
            };
            list.push(d);
          }
        });
      } else {
        var d = {
          basket_id: basketid,
          broker_id: brokerid,
          quantity: quantity,
        };
        list.push(d);
      }

      if (!this.state.hagheTaghadom) {
        type = "bounsShare";
      } else {
        type = "rightShare";
      }

      if (this.state.dpsAuto && this.state.submitedSuggestion.length === 0) {
        this.submitDivision(null);
        return;
      }

      let data = {
        mobile: localStorage.getItem("mobile"),
        token: localStorage.getItem("token"),
        type: type,
        symbol_id: symbolid,
        symbol_txt: symboltxt,
        date: date,
        list: list,
      };

      if (this.state.isEdit) {
        this.editAction(data, brokerid, basketid, quantity);
        return;
      }

      this.setState({ buttonDisabled: true });
      fetch("/api/transaction", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((resultt) => {
          if (resultt.status === 200) {
            this.props.submitIncreaseDevisionSuccess();
            this.props.onRefresh();

            this.resetForm();

            toast.success("سند مورد نظر با موفقیت ثبت گردید", {
              position: toast.POSITION.BOTTOM_LEFT,
              hideProgressBar: true,
              autoClose: 8000,
              toastClassName: "toast",
            });
            // alert("سند مورد نظر با موفقیت ثبت گردید");
          } else if (resultt.status === 401) {
            this.setState({ Redirect: true });
          } else {
            toast.error(resultt.message, {
              position: toast.POSITION.BOTTOM_LEFT,
              hideProgressBar: true,
              autoClose: 8000,
              toastClassName: "toast",
            });
          }
          this.setState({ buttonDisabled: false });
        });
    } catch (error) {
      this.setState({ buttonDisabled: false });
    }
  }

  radioNormalChange() {
    if (this.radioNormal.checked) {
      this.setState({
        hagheTaghadom: false,
        selectedSymbol: null,
        selectedSymbol1: null,
      });
    }
  }

  radioHaghChange() {
    if (this.radioHagh.checked) {
      this.setState({
        hagheTaghadom: true,
        selectedSymbol: null,
        selectedSymbol1: null,
      });
    }
  }

  setBasketValue(name, readonly) {
    this.setState(
      { currentBasketLable: name, currentBasketReadolny: readonly },
      () => {
        if (!this.state.dpsAuto) {
          this.acBaskets.value = name;
          this.acBaskets.readonly = readonly;
        }
      }
    );
  }

  setBrokerValue(name, readonly) {
    this.setState(
      { currentBrokerLable: name, currentBrokerReadolny: readonly },
      () => {
        if (!this.state.dpsAuto) {
          this.acBrokers.value = name;
          this.acBrokers.readonly = readonly;
        }
      }
    );
  }

  getMainSymbolID() {
    let data = {
      mobile: localStorage.getItem("mobile"),
      token: localStorage.getItem("token"),
      word: this.state.selectedSymbol.symbol
        .substring(0, this.state.selectedSymbol.symbol.length - 1)
        .trim(),
      type: "stick",
    };

    fetch("/api/searchSymbol", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((resultt) => {
        if (resultt.status === 200) {
          this.submitDivision(resultt.result[0].id);
          // this.setState({options:resultt.result,isLoading:false})
        }
      });
  }

  submitDivision(mainsymbolid) {
    try {
      let symbolid;

      if (this.state.hagheTaghadom) {
        if (mainsymbolid === null) {
          this.getMainSymbolID();
          return;
        } else {
          symbolid = mainsymbolid;
        }
      } else {
        if (this.state.selectedSymbol !== null)
          symbolid = this.state.selectedSymbol.id;
      }

      let cash = this.state.quantitychange
        .toString()
        .replace(/,/g, "")
        .replace(/ /g, "")
        .replace(/ریال/g, "");
      let data = {
        mobile: localStorage.getItem("mobile"),
        token: localStorage.getItem("token"),
        symbol_id: symbolid,
        total: cash,
        type: "bounsShare",
      };
      this.setState({
        buttonDisabled: true,
        buttonSpinner: false,
        buttonDisabledDivision: true,
        buttonSpinnerDivision: true,
      });
      fetch("/api/suggestDivision", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((resultt) => {
          if (resultt.status === 200) {
            if (resultt.result.length > 0) {
              this.props.showSuggestion(resultt.result);
            } else {
              toast.error("نماد مورد نظر در هیچ یک از سبدها موجود نیست", {
                position: toast.POSITION.BOTTOM_LEFT,
                hideProgressBar: true,
                autoClose: 8000,
                toastClassName: "toast",
              });
            }
          } else if (resultt.status === 401) {
            this.setState({ Redirect: true });
          } else {
            toast.error(resultt.message, {
              position: toast.POSITION.BOTTOM_LEFT,
              hideProgressBar: true,
              autoClose: 8000,
              toastClassName: "toast",
            });
          }
          this.setState({
            buttonDisabled: false,
            buttonSpinner: false,
            buttonDisabledDivision: false,
            buttonSpinnerDivision: false,
          });
        });
    } catch (error) {
      this.setState({
        buttonDisabled: false,
        buttonSpinner: false,
        buttonDisabledDivision: false,
        buttonSpinnerDivision: false,
      });
    }
  }

  check1Change() {
    if (this.check1.checked) {
      this.setState({ dpsAuto: true });
    } else {
      this.setState({ dpsAuto: false }, () => {
        this.acBaskets.value = this.state.currentBasketLable;
        this.acBaskets.readonly = this.state.currentBasketReadolny;
        this.acBrokers.value = this.state.currentBrokerLable;
        this.acBrokers.readonly = this.state.currentBrokerReadolny;
      });
    }
  }

  suggestionSubmit(data) {
    this.setState({ submitedSuggestion: data }, () => {
      this.SubmitFrom();
    });
  }

  itemTemplate(data) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          justifyContent: "space-between",
        }}
      >
        <div>{data.broker_name}</div>
        {data.lable !== null &&
          data.lable !== "" &&
          data.lable !== undefined && (
            <div style={{ fontSize: "12px", color: "var(--gray1)" }}>
              {data.lable}
            </div>
          )}
      </div>
    );
  }

  cancelForm() {
    if (this.props.isPopup) {
      this.props.cancelForm();
      return;
    } else {
      this.resetForm();
    }
  }

  resetForm() {
    // if (this.props.isPopup){
    //     this.props.cancelForm();
    //     return;
    // }
    this.setState({
      quantitychange: "",
      isEdit: null,
      selectedSymbol: null,
      selectedSymbol1: null,
      submitedSuggestion: [],
      dateErrorText: "",
      symbolErrorText: "",
      quantityErrorText: "",
      basketErrorText: "",
      brokerErrorText: "",
      dateFalse: false,
      symbolFalse: false,
      quantityFalse: false,
      basketFalse: false,
      brokerFalse: false,
    });
    document.querySelectorAll(".rbt-input-main")[2].style.border =
      "1px solid #ced4da";
    if (!this.state.hagheTaghadom) this.acSymbol.clear();
    if (this.state.hagheTaghadom) this.acSymbol1.clear();

    this.check1.checked = true;
    this.radioNormal.checked = true;

    this.setState({ dpsAuto: true });

    if (!this.state.dpsAuto) {
      if (
        this.props.selectedPortfolioId === 0 &&
        this.props.userBasketsData.length > 1
      ) {
        this.acBaskets.value = "";
      }
      if (
        this.props.selectedBrokerId === 0 &&
        this.props.userBrokersData.length > 1
      ) {
        this.acBrokers.value = "";
      }
    }
  }

  editFrom(data) {
    if (data.type_id === 7) {
      this.radioNormal.checked = true;
      this.setState({ hagheTaghadom: false });
    } else {
      this.radioHagh.checked = true;
      this.setState({ hagheTaghadom: true });
    }

    this.check1.checked = false;

    this.setState(
      {
        quantitychange: Math.abs(data.quantity),
        dateValue: moment(data.date, "jYYYY-jMM-jDD").format("jYYYY/jMM/jDD"),
        dpsAuto: false,
      },
      () => {
        if (this.props.userBasketsData.length > 0) {
          this.acBaskets.value = data.basket;
        }
        if (this.props.userBrokersData.length > 0) {
          if (data.lable !== null && data.lable !== "") {
            this.acBrokers.value = data.broker + " (" + data.lable + ")";
          } else {
            this.acBrokers.value = data.broker;
          }
        }
      }
    );

    // let symbol=[];
    // symbol.push(data.full_name)
    // this.setState({selectedSymbol:symbol})
    this.getSymbol(data.symbol, data.symbol_id);
    this.setState({ isEdit: data });
  }

  editAction(body, brokerid, basketid, quantity) {
    let data = body;

    let d = [];
    if (this.state.isEdit.child === undefined) {
      d.push(this.state.isEdit);
    } else {
      this.state.isEdit.child.forEach((element) => {
        d.push(element);
      });
    }
    data.list = d;

    data.basket_id = basketid;
    data.broker_id = brokerid;
    data.quantity_change = Number(quantity);

    // console.log(data);

    this.setState({ buttonDisabled: true });
    fetch("/api/editTransaction", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((resultt) => {
        if (resultt.status === 200) {
          this.props.onRefresh();

          this.resetForm();
          toast.success("سند با موفقیت ویرایش شد", {
            position: toast.POSITION.BOTTOM_LEFT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        } else if (resultt.status === 401) {
          this.setState({ Redirect: true });
        } else {
          toast.error(resultt.message, {
            position: toast.POSITION.BOTTOM_LEFT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
        }
        this.setState({ buttonDisabled: false });
      })
      .catch((err) => {
        this.setState({ buttonDisabled: false });
      });
  }

  render() {
    if (this.state.Redirect) return <Redirect to="/Login" />;
    return (
      <div className="contentStyle">
        <div id="componentsParent" style={{ minHeight: "340px" }}>
          <div className="InputWithIcon" style={{ direction: "ltr" }}>
            <div className="inputImageDiv">
              <img src={dateicon} className="inputImage" alt="date" />
            </div>
            {/* <DatePicker
                            className={this.state.dateFalse ? "form-control inputStyleRed":"form-control inputStyleForm"}
                            timePicker={false}
                            isGregorian={false}
                            ref={(scope) => this.datepickerr = scope}
                            onChange={valuee => this.dateChange(valuee)}
                            value={this.state.dateValue}
                            max={this.state.maxDateStart}
                        /> */}
            <DatePicker
              ref={this.datepickerr}
              value={this.state.dateValue}
              inputClass={
                this.state.dateFalse
                  ? "form-control inputStyleRed"
                  : "form-control inputStyleForm"
              }
              calendar="persian"
              locale="fa"
              weekDays={["ش", "ی", "د", "س", "چ", "پ", "ج"]}
              format="YYYY/MM/DD"
              animation
              className={this.props.isPopup ? "rmdp-mobile bluee" : "bluee"}
              onChange={(valuee) => this.dateChange(valuee)}
              maxDate={this.state.maxDateStart}
              editable={false}
              inputMode="none"
              fixMainPosition={true}
              fixRelativePosition={true}
              placeholder="تاریخ"
            />
          </div>
          <div className="errorMessage1">{this.state.dateErrorText}</div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              height: "50px",
              justifyContent: "space-between",
              margin: "12px 0px",
            }}
          >
            <RadioButtonComponent
              ref={(scope) => (this.radioNormal = scope)}
              change={this.radioNormalChange.bind(this)}
              label="از محل سود انباشته و یا تجدید ارزیابی (سهام جایزه)"
              enableRtl="true"
              name="typee"
              checked={true}
            />
            <RadioButtonComponent
              ref={(scope) => (this.radioHagh = scope)}
              change={this.radioHaghChange.bind(this)}
              label="از محل آورده نقدی (حق تقدم)"
              enableRtl="true"
              name="typee"
            />
          </div>
          {!this.state.hagheTaghadom && (
            <AsyncTypeahead
              id="symbolAuto"
              searchText="در حال جستجو..."
              promptText="لطفاً نام نماد مورد نظر را تایپ کنید"
              paginationText="نمایش موارد بیشتر ..."
              useCache={true}
              ref={(scope) => (this.acSymbol = scope)}
              isLoading={this.state.isLoading}
              labelKey="full_name"
              minLength={2}
              onSearch={this.searchSymbol.bind(this)}
              onInputChange={(text) => {
                if (text === "")
                  this.setState({
                    selectedSymbol: null,
                    selectedSymbol1: null,
                  });
              }}
              options={this.state.options}
              placeholder="نماد"
              delay={100}
              emptyLabel="موردی یافت نشد"
              flip={true}
              clearButton={true}
              onChange={this.acSymbolChange.bind(this)}
              selected={this.state.selectedSymbol1}
            />
          )}
          {this.state.hagheTaghadom && (
            <AsyncTypeahead
              id="symbolAuto"
              searchText="در حال جستجو..."
              promptText="لطفاً نام نماد حق تقدم مورد نظر را تایپ کنید"
              paginationText="نمایش موارد بیشتر ..."
              useCache={true}
              ref={(scope) => (this.acSymbol1 = scope)}
              isLoading={this.state.isLoading}
              labelKey="full_name"
              minLength={2}
              onSearch={this.searchSymbol.bind(this)}
              onInputChange={(text) => {
                if (text === "")
                  this.setState({
                    selectedSymbol: null,
                    selectedSymbol1: null,
                  });
              }}
              options={this.state.options}
              placeholder="نماد حق تقدم"
              delay={100}
              emptyLabel="موردی یافت نشد"
              flip={true}
              clearButton={true}
              onChange={this.acSymbolChange.bind(this)}
              selected={this.state.selectedSymbol1}
            />
          )}
          <div className="errorMessage1">{this.state.symbolErrorText}</div>

          {/* <NumberFormat 
                    placeholder="تعداد"
                    className={this.state.quantityFalse ? "form-control inputStyleRed":"form-control inputStyleForm"}
                    displayType={'input'} 
                    thousandSeparator={true} 
                    onChange={this.quantitychange}
                    value={this.state.quantitychange}  />
                    <div className="errorMessage1">{this.state.quantityErrorText}</div> */}

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <CheckBoxComponent
              disabled={this.state.isEdit}
              className="checkBoxContainer"
              label="تقسیم خودکار تعداد به نسبت سبدها"
              checked
              ref={(scope) => (this.check1 = scope)}
              change={this.check1Change.bind(this)}
              enableRtl="true"
            />
          </div>

          <div className="dpsCostContainer">
            <div className="dpsTextContainer">
              <NumberFormat
                placeholder="تعداد کل سهام تعلق یافته"
                className={
                  this.state.quantityFalse
                    ? "form-control inputStyleRed"
                    : "form-control inputStyleForm"
                }
                displayType={"input"}
                thousandSeparator={true}
                onChange={this.quantitychange}
                value={this.state.quantitychange}
              />
            </div>
            {/* {this.state.dpsAuto && <Button variant="secondary" className="dpsButtonStyle" disabled={this.state.quantitychange!==null && this.state.quantitychange!=='' && this.state.selectedSymbol!==null && !this.state.buttonDisabledDivision ? false:true} onClick={this.submitDivision.bind(this)}>{this.state.buttonSpinnerDivision && <Spinner className="spinnerStyle" animation="border" />}{!this.state.buttonSpinnerDivision && <div>محاسبه</div>}</Button>} */}
          </div>
          <div className="errorMessage1">{this.state.quantityErrorText}</div>

          {!this.state.dpsAuto && (
            <AutoCompleteComponent
              showPopupButton={true}
              className={
                this.state.basketFalse ? "inputStyleRed" : "inputStyleForm"
              }
              ref={(scope) => (this.acBaskets = scope)}
              filterType="Contains"
              enableRtl="true"
              noRecordsTemplate="موردی یافت نشد"
              popupHeight="550px"
              dataSource={this.props.userBasketsData}
              fields={this.fields1}
              placeholder="سبد"
              autofill={true}
            />
          )}
          {!this.state.dpsAuto && (
            <div className="errorMessage1">{this.state.basketErrorText}</div>
          )}
          {!this.state.dpsAuto && (
            <AutoCompleteComponent
              itemTemplate={this.itemTemplate}
              showPopupButton={true}
              className={
                this.state.brokerFalse ? "inputStyleRed" : "inputStyleForm"
              }
              ref={(scope) => (this.acBrokers = scope)}
              filterType="Contains"
              enableRtl="true"
              noRecordsTemplate="موردی یافت نشد"
              popupHeight="550px"
              dataSource={this.props.userBrokersData}
              fields={this.fields2}
              placeholder="کارگزاری"
              autofill={true}
            />
          )}
          {!this.state.dpsAuto && (
            <div className="errorMessage1">{this.state.brokerErrorText}</div>
          )}

          {!this.state.isEdit && !this.props.isPopup && !this.state.dpsAuto && (
            <Button
              variant="secondary"
              className="formButtonStyle"
              disabled={this.state.buttonDisabled}
              onClick={this.SubmitFrom.bind(this)}
            >
              {this.state.buttonDisabled && (
                <Spinner className="spinnerStyle" animation="border" />
              )}
              {!this.state.buttonDisabled && <div>ثبت</div>}
            </Button>
          )}
          {!this.state.isEdit && !this.props.isPopup && this.state.dpsAuto && (
            <Button
              variant="secondary"
              className="formButtonStyle"
              disabled={this.state.buttonDisabledDivision}
              onClick={this.SubmitFrom.bind(this)}
            >
              {this.state.buttonSpinnerDivision && (
                <Spinner className="spinnerStyle" animation="border" />
              )}
              {!this.state.buttonSpinnerDivision && <div>تایید</div>}
            </Button>
          )}
          {/* {(this.state.isEdit || this.props.isPopup) && <div style={{display:'flex',flexDirection:'row',marginTop:'20px',justifyContent:'space-between',width:'100%'}}>
                        <Button variant="danger" onClick={this.resetForm.bind(this)} style={{minWidth:'45%',fontSize:'13px',height:'30px'}}>انصراف</Button>
                        <div style={{width:'10px'}}/>
                        <Button variant={this.state.isEdit ? "primary":"secondary"} style={{minWidth:'45%',fontSize:'13px',height:'30px'}} disabled={this.state.buttonDisabled} onClick={this.SubmitFrom.bind(this)}>{this.state.buttonDisabled && <Spinner className="spinnerStyle" animation="border" />}{!this.state.buttonDisabled && this.state.isEdit && <div>ویرایش</div>}{!this.state.buttonDisabled && !this.state.isEdit && <div>ثبت&nbsp;{this.state.buttonTitle}</div>}</Button>
                    </div>} */}

          {(this.state.isEdit || this.props.isPopup) && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: "20px",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <Button
                variant="danger"
                onClick={this.cancelForm.bind(this)}
                style={{ minWidth: "45%", fontSize: "13px", height: "30px" }}
              >
                انصراف
              </Button>
              <div style={{ width: "10px" }} />
              {!this.state.dpsAuto && (
                <Button
                  variant={this.state.isEdit ? "primary" : "secondary"}
                  style={{ minWidth: "45%", fontSize: "13px", height: "30px" }}
                  disabled={this.state.buttonDisabled}
                  onClick={this.SubmitFrom.bind(this)}
                >
                  {this.state.buttonSpinner && (
                    <Spinner className="spinnerStyle" animation="border" />
                  )}
                  {!this.state.buttonSpinner && this.state.isEdit && (
                    <div>ویرایش</div>
                  )}
                  {!this.state.buttonSpinner && !this.state.isEdit && (
                    <div>ثبت</div>
                  )}
                </Button>
              )}
              {this.state.dpsAuto && (
                <Button
                  variant={this.state.isEdit ? "primary" : "secondary"}
                  style={{ minWidth: "45%", fontSize: "13px", height: "30px" }}
                  disabled={this.state.buttonDisabledDivision}
                  onClick={this.SubmitFrom.bind(this)}
                >
                  {this.state.buttonSpinnerDivision && (
                    <Spinner className="spinnerStyle" animation="border" />
                  )}
                  {!this.state.buttonSpinnerDivision && this.state.isEdit && (
                    <div>ویرایش</div>
                  )}
                  {!this.state.buttonSpinnerDivision && !this.state.isEdit && (
                    <div>تایید</div>
                  )}
                </Button>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}
